import { Redirect } from 'react-router-dom';
import { Permissions } from '../../shared/auth/constants/permissions';
import { useHasPermission } from '../Session';
import BasicLayout from '../layouts/BasicLayout';
import Approvals from '../pages/Approvals';

const ApprovalsRoute = () => {
    const canApproveUsers = useHasPermission(Permissions.USER_ACCOUNT_APPROVAL);

    if (!canApproveUsers) {
        return <Redirect to="/403" />;
    }

    return (
        <BasicLayout>
            <Approvals />
        </BasicLayout>
    );
};

export default ApprovalsRoute;
